<!--
 * @Author: your name
 * @Date: 2021-09-27 17:48:35
 * @LastEditTime: 2022-05-18 13:56:55
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\strategy\logistics\orderMoney\components\DataForm.vue
-->
<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <el-col :span="span">
      <ItemPriceType v-model="form.type" />
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingOrderMoney.dialog.amountRange')" required>
        <el-row>
          <el-col :span="11">
            <el-form-item prop="amountStart">
              <BjInputMoney v-model="form.amountStart" />
            </el-form-item>
          </el-col>
          <el-col class="text-center" :span="2"> - </el-col>
          <el-col :span="11">
            <el-form-item prop="amountEnd">
              <BjInputMoney v-model="form.amountEnd" />
            </el-form-item> </el-col
        ></el-row>
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingOrderMoney.dialog.logistics')" prop="logisticCompanyId">
        <BjSelectLogisticCompany
          :value="form.logisticCompanyId"
          :default-options="{
            label: form.logisticCompanyName,
            value: form.logisticCompanyId,
          }"
          @change="onLogistic"
        />
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingOrderMoney.dialog.business')" prop="logisticBusinessId">
        <BjSelectLogisticBusiness
          :value="form.logisticBusinessId"
          :disabled="!form.logisticCompanyId"
          :default-params="defaultParams"
          :default-options="{
            label: form.logisticBusinessName,
            value: form.logisticBusinessId,
          }"
          :placeholder="form.logisticCompanyId ? $t('chooseText') : $t('settingOrderMoney.dialog.selectLogisticsValid')"
          @change="onBusiness"
        />
      </el-form-item>
      <el-form-item :label="$t('settingOrderMoney.dialog.priority')" prop="orderNum">
        <el-input-number
          v-model="form.orderNum"
          :maxlength="MAX_LENGTH.DEFAULT"
          :min="0"
          :max="MAX_LENGTH.PRIORITY"
          :precision="0"
          :controls="false"
        />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { settingApi } from '@/api';
import ItemPriceType from './ItemPriceType.vue';
const getDefaultForm = () => {
  return {
    type: null,
    amountStart: null,
    amountEnd: null,
    logisticCompanyId: null,
    logisticCompanyNo: null,
    logisticCompanyName: null,
    logisticBusinessId: null,
    logisticBusinessNo: null,
    logisticBusinessName: null,
    orderNum: null,
    enabledFlag: true,
  };
};

export default {
  components: { ItemPriceType },
  data() {
    return {
      span: 22,
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
    };
  },
  computed: {
    rules() {
      // 表单校验
      const rules = {
        type: [{ required: true, message: this.$t('settingOrderMoney.dialog.selectAmountType'), trigger: 'change' }],
          amountStart: [{ required: true, message: this.$t('settingOrderMoney.dialog.amountValid'), trigger: 'blur' }],
          logisticCompanyId: [{ required: true, message: this.$t('settingOrderMoney.dialog.selectLogistics'), trigger: 'change' }],
          logisticBusinessId: [{ required: true, message: this.$t('settingOrderMoney.dialog.selectBusiness'), trigger: 'change' }],
          orderNum: [{ required: true, message: this.$t('settingOrderMoney.dialog.priorityValid'), trigger: 'blur' }],
      };
      return rules;
    },
    defaultParams() {
      // 以 所属物流商 为默认参数
      return { companyId: this.form.logisticCompanyId, enableFlag: true };
    },
  },
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('settingOrderMoney.dialog.editTitle') : this.$t('settingOrderMoney.dialog.addTitle'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    onLogistic(val, data = {}) {
      this.form.logisticCompanyId = data.id;
      this.form.logisticCompanyNo = data.code;
      this.form.logisticCompanyName = data.name;

      this.form.logisticBusinessId = null;
      this.form.logisticBusinessNo = null;
      this.form.logisticBusinessName = null;
    },
    onBusiness(val, data = {}) {
      this.form.logisticBusinessId = data.id;
      this.form.logisticBusinessNo = data.code;
      this.form.logisticBusinessName = data.name;
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }
      this.saveApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },

    saveApi(API_DATA) {
      if (this.isEdit) {
        settingApi.updateStrategyOrderAmounts(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      } else {
        settingApi.addStrategyOrderAmounts(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
